import { toast } from "sonner";
import { Pencil, Trash2 } from "lucide-react";
import { api, fmtErr, img, money } from "@/lib/api";

export const selectCls = "rounded-sm border border-[#3b1d63] bg-[#07030c] px-3 py-2 text-sm text-[#f3eefc] outline-none focus:border-[#a855f7]";

export const ListingsTab = ({ products, onEdit, reload }) => {
  const setStatus = async (p, status) => {
    try { await api.patch(`/admin/products/${p.id}/status`, { status }); toast.success(`Marked ${status}`); reload(); } catch (e) { toast.error(fmtErr(e)); }
  };
  const remove = async (p) => {
    if (!window.confirm(`Delete "${p.title}"?`)) return;
    try { await api.delete(`/admin/products/${p.id}`); toast.success("Listing deleted"); reload(); } catch (e) { toast.error(fmtErr(e)); }
  };
  if (!products.length) return <p className="py-16 text-center text-[#cbbbe6]">No listings yet. Add your first piece.</p>;
  return (
    <ul className="divide-y divide-[#281245] border-y border-[#281245]" data-testid="admin-listings">
      {products.map((p) => (
        <li key={p.id} className="flex flex-wrap items-center gap-4 py-4 md:flex-nowrap" data-testid={`admin-listing-${p.id}`}>
          <img src={img(p.images?.[0])} alt="" className="h-16 w-14 shrink-0 object-cover" />
          <div className="min-w-0 flex-1">
            <p className="truncate text-[#f3eefc]">{p.title}</p>
            <p className="font-mono-j text-xs text-[#a78bce]">{p.brand} · {p.category}{p.size ? ` · ${p.size}` : ""}</p>
          </div>
          <p className="font-mono-j w-20 text-[#f3eefc]">{money(p.price)}</p>
          <select value={p.status} onChange={(e) => setStatus(p, e.target.value)} className={selectCls} data-testid={`admin-status-select-${p.id}`}>
            {["Available", "Reserved", "Sold"].map((s) => <option key={s}>{s}</option>)}
          </select>
          <button onClick={() => onEdit(p)} className="p-2 text-[#cbbbe6] hover:text-white" aria-label="Edit" data-testid={`admin-edit-button-${p.id}`}><Pencil className="h-4 w-4" /></button>
          <button onClick={() => remove(p)} className="p-2 text-[#cbbbe6] hover:text-red-400" aria-label="Delete" data-testid={`admin-delete-button-${p.id}`}><Trash2 className="h-4 w-4" /></button>
        </li>
      ))}
    </ul>
  );
};
